import { render } from "./file.vue?vue&type=template&id=b03ee888"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/form/horizontal/file.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b03ee888"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b03ee888', __exports__)) {
    console.log('reload')
    api.reload('b03ee888', __exports__)
  }
  
  module.hot.accept("./file.vue?vue&type=template&id=b03ee888", () => {
    console.log('re-render')
    api.rerender('b03ee888', render)
  })

}


export default __exports__